import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { IdentityService } from '../_services/identity.service';

@Component({
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.css']
})
export class PasswordChangeComponent implements OnInit {
 submitted=false;
  definitionForm:FormGroup;
  constructor(private formBuilder:FormBuilder,
      private activeModal:NgbActiveModal,
   private identityService:IdentityService,
   
      private toastr: ToastrService) { }

  ngOnInit() {

      this.definitionForm=this.formBuilder.group({
     
      'password':['']
    });
  }
 close(){
    this.activeModal.close();
  }
  save(){
    this.submitted=true;
    if(this.definitionForm.invalid){
      return;
    }
  
    this.identityService.changePassword(this.definitionForm.value).subscribe(data=>{
     this.toastr.success("Şifre başarıyla değiştirildi");
      this.close();
    },error=>{
      this.toastr.error(error.error);
    });
   
  }
}
